import {
  SEARCH,
  STATUS,
  SORT,
} from './fields';

export default function payload() {
  return {
    email: {
      field: SEARCH,
    },
    invitation_accepted: {
      field: STATUS,
    },
    sort: {
      field: SORT,
    },
  };
}
